import { makeStyles } from '@material-ui/core/styles';

export const usePromotionsMobileStyles = makeStyles(() => ({
    pageHeader: {
        padding: '12px 16px',
        borderBottom: '1px solid #ECECF2',
    },
    pageTitle: {
        fontWeight: 600,
        fontSize: 18,
        lineHeight: 1.3,
    },
    pageSubtitle: {
        fontSize: 13,
        color: '#6B7280',
        marginTop: 4,
    },
    headerActions: {
        display: 'flex',
        marginTop: 12,
        width: '100%',
        '& > *:not(:first-child)': {
            marginLeft: 10,
        },
    },
    headerActionButton: {
        flex: 1,
        minWidth: 0,
        textTransform: 'none',
        fontWeight: 600,
        fontSize: 13,
        padding: '8px 10px',
        borderRadius: 10,
    },
    headerActionButtonWrap: {
        display: 'flex',
        flex: 1,
        minWidth: 0,
        '& .MuiButton-root': {
            width: '100%',
        },
    },
    headerActionButtonWrapFull: {
        display: 'flex',
        width: '100%',
        '& .MuiButton-root': {
            width: '100%',
        },
    },
    listContainer: {
        padding: '12px 16px 96px',
    },
    ruleCard: {
        marginBottom: 12,
        borderRadius: 12,
        border: '1px solid #E8E8E8',
        boxShadow: 'none',
    },
    ruleCardContent: {
        padding: '14px 14px 12px !important',
        '&:last-child': {
            paddingBottom: '12px !important',
        },
    },
    ruleMetaRow: {
        display: 'flex',
        flexWrap: 'wrap',
        gap: 6,
        marginTop: 10,
    },
}));

export const usePromotionsActionButtonStyles = makeStyles((theme) => ({
    actionButton: {
        textTransform: 'none',
        boxShadow: 'none',
        transition: theme.transitions.create(['background-color', 'box-shadow', 'transform'], {
            duration: theme.transitions.duration.short,
        }),
        '&:hover': {
            boxShadow: '0 3px 10px rgba(23, 51, 0, 0.2)',
            transform: 'translateY(-1px)',
            backgroundColor: '#8ed65f',
        },
        '&:active': {
            transform: 'translateY(0)',
            boxShadow: 'none',
        },
    },
}));

export const usePromotionsTableStyles = makeStyles({
    tableContainer: {
        border: '1px solid #E8E8E8',
        borderRadius: 8,
        overflow: 'hidden',
    },
    table: {
        tableLayout: 'fixed',
        width: '100%',
    },
    headCell: {
        fontWeight: 600,
        fontSize: 13,
        color: '#6B7280',
        backgroundColor: '#FAFAFA',
        borderBottom: '1px solid #E8E8E8',
        padding: '12px 16px',
        whiteSpace: 'nowrap',
    },
    bodyCell: {
        fontSize: 14,
        color: '#1F2937',
        padding: '14px 16px',
        verticalAlign: 'middle',
        borderBottom: '1px solid #ECECF2',
    },
    nameCell: {
        fontWeight: 500,
        width: '18%',
    },
    typeCell: {
        width: '12%',
    },
    discountCell: {
        width: '28%',
    },
    scopeCell: {
        width: '16%',
    },
    statusCell: {
        width: '10%',
    },
    activeCell: {
        width: '8%',
    },
    actionsCell: {
        width: '8%',
    },
});
